<template>
  <div class="history">
    <div class="history__title">
      <div class="history__title--big bg-primary text-white history--pd">
        Vehicle History Report
      </div>
      <div class="history__title--slim bg-primary text-white history--pd">
        VIN:
        <div class="history__title--slim" style="margin-left:5px">
          {{ report.vin }}
        </div>
      </div>
    </div>
    <div class="history_content text-white" style="margin-top:10px">
      <div class="history__title--big bg-green-5 text-white history--pd">
        Vehicle Specifications
      </div>
      <div class="history__vehicle history--pd text-dark">
        <div class="history__vehicle--item">
          <div class="history__vehicle--item__title">VIN:</div>
          {{ report.vehicle.vin }}
        </div>
        <div class="history__vehicle--item">
          <div class="history__vehicle--item__title">Model YEAR:</div>
          {{ report.vehicle.model_year }}
        </div>
        <div class="history__vehicle--item">
          <div class="history__vehicle--item__title">Brand:</div>
          {{ report.vehicle.brand.name }}
        </div>
        <div class="history__vehicle--item">
          <div class="history__vehicle--item__title">Model:</div>
          {{ report.vehicle.model.name }}
        </div>
        <div class="history__vehicle--item">
          <div class="history__vehicle--item__title">Trim:</div>
          {{ report.values.attributes.trim }}
        </div>
        <div class="history__vehicle--item">
          <div class="history__vehicle--item__title">Made in:</div>
          {{ report.values.attributes.made_in }}
        </div>
      </div>
    </div>
    <div class="history_content text-white" style="margin-top:-1px">
      <div class="history__title--big bg-green-5 text-white history--pd">
        Title Records
      </div>
      <div class="history__vehicle history--pd text-dark">
        <div v-for="val in report.values.titles" :key="val.vin">
          <div class="history__vehicle--item">
            <div class="history__vehicle--item__title">Date:</div>
            {{ usaDateFormatter(val.date) }}
          </div>
          <div class="history__vehicle--item">
            <div class="history__vehicle--item__title">State:</div>
            {{ val.state }}
          </div>
          <div class="history__vehicle--item">
            <div class="history__vehicle--item__title">VIN:</div>
            {{ val.vin }}
          </div>
          <div class="history__vehicle--item">
            <div class="history__vehicle--item__title">Mileage:</div>
            {{ comma(val.mileage) }}
          </div>
        </div>
        <div
          class="history__vehicle--item no-bd"
          v-if="report.values.titles.length === 0"
        >
          No records found.
        </div>
      </div>
    </div>
    <div class="history_content text-white" style="margin-top:-1px">
      <div class="history__title--big bg-green-5 text-white history--pd">
        Accident Records
      </div>
      <div class="history__vehicle history--pd text-dark">
        <div v-for="(val, index) in report.values.accidents" :key="index">
          <div class="history__vehicle--item--33">
            <div class="history__vehicle--item__title">Date:</div>
            {{ usaDateFormatter(val.date) }}
          </div>
          <div class="history__vehicle--item--33">
            <div class="history__vehicle--item__title">Type:</div>
            {{ val.type }}
          </div>
          <div class="history__vehicle--item--33">
            <div class="history__vehicle--item__title">
              Manner of Collision:
            </div>
            {{ val.manner_of_collision }}
          </div>
        </div>
        <div
          class="history__vehicle--item no-bd"
          v-if="report.values.accidents.length === 0"
        >
          No records found.
        </div>
      </div>
    </div>
    <div class="history_content text-white" style="margin-top:-1px">
      <div class="history__title--big bg-green-5 text-white history--pd">
        Junk / Salvage / Insurance Records
      </div>
      <div class="history__vehicle history--pd text-dark">
        <div v-for="(val, index) in report.values.jsi" :key="index">
          <div class="history__vehicle--item">
            <div class="history__vehicle--item__title">Date:</div>
            {{ usaDateFormatter(val.date) }}
          </div>
          <div class="history__vehicle--item">
            <div class="history__vehicle--item__title">State:</div>
            {{ val.record_type }}
          </div>
        </div>
        <div
          class="history__vehicle--item no-bd"
          v-if="report.values.titles.length === 0"
        >
          No records found.
        </div>
      </div>
    </div>
    <div class="history_content text-white" style="margin-top:-1px">
      <div class="history__title--big bg-green-5 text-white history--pd">
        Theft Records
      </div>
      <div class="history__vehicle history--pd text-dark">
        <div v-for="(val, index) in report.values.thefts" :key="index">
          <div class="history__vehicle--item--33">
            <div class="history__vehicle--item__title">Date:</div>
            {{ usaDateFormatter(val.date) }}
          </div>
          <div class="history__vehicle--item--33">
            <div class="history__vehicle--item__title">Theft Status:</div>
            {{ val.theft_status }}
          </div>
          <div class="history__vehicle--item--33">
            <div class="history__vehicle--item__title">Record Type:</div>
            {{ val.record_type }}
          </div>
        </div>
        <div
          class="history__vehicle--item no-bd"
          v-if="report.values.thefts.length === 0"
        >
          No records found.
        </div>
      </div>
    </div>
    <div class="history_content text-white" style="margin-top:-1px">
      <div class="history__title--big bg-green-5 text-white history--pd">
        Salvage Records
      </div>
      <div class="history__vehicle history--pd text-dark">
        <div v-for="(val, index) in report.values.salvage" :key="index">
          <div class="history__vehicle--item--33">
            <div class="history__vehicle--item__title">Date:</div>
            {{ usaDateFormatter(val.date) }}
          </div>
          <div class="history__vehicle--item--33">
            <div class="history__vehicle--item__title">Type:</div>
            {{ val.type }}
          </div>
          <div class="history__vehicle--item--33">
            <div class="history__vehicle--item__title">Primary Damage</div>
            {{ val.primary_damage }}
          </div>
        </div>
        <div
          class="history__vehicle--item no-bd"
          v-if="report.values.salvage.length === 0"
        >
          No records found.
        </div>
      </div>
    </div>
    <div class="history_content text-white" style="margin-top:-1px">
      <div class="history__title--big bg-green-5 text-white history--pd">
        Title Checks
      </div>
      <div class="history__vehicle history--pd text-dark">
        <div v-for="(val, index) in report.values.checks" :key="index">
          <div class="history__vehicle--item">
            <div class="history__vehicle--item__title">Date:</div>
            {{ usaDateFormatter(val.date) }}
          </div>
          <div class="history__vehicle--item">
            <div class="history__vehicle--item__title">Description:</div>
            {{ val.description }}
          </div>
        </div>
        <div
          class="history__vehicle--item no-bd"
          v-if="report.values.checks.length === 0"
        >
          No records found.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    report: {
      type: Object,
      required: false,
    },
  },
  methods: {
    comma() {
      return (val) => val.toLocaleString("en-US");
    },
    usaDateFormatter() {
      return (val) => new Date(val).toLocaleDateString("en-US");
    },
  }
};
</script>
<style lang="scss" scoped>
.no-bd {
  border-bottom: none !important;
}
.history--pd {
  padding: 0 10px;
}
.history {
  border-bottom: 1px solid #ccc;
  padding: 15px;
}
.history__title {
  display: flex;
  flex-flow: column nowrap;
}
.history__title--big {
  font-size: 25px;
  font-weight: bold;
}
.history__title--slim {
  display: flex;
  font-size: 20px;
  font-weight: 300;
}
.history__vehicle {
  display: flex;
  background: #f5f5f5;
  flex-flow: row wrap;
  flex: 1;
  .history__vehicle--item {
    display: flex;
    border-bottom: 1px solid #ccc;
    padding: 5px 0;
    align-items: center;
    flex: 0 1 50%;
  }
}
.history__vehicle--item__title {
  font-weight: 500;
  color: #000;
  margin-right: 5px;
  font-size: 15px;
}
.history__vehicle--item--33 {
  display: flex;
  border-bottom: 1px solid #ccc;
  padding: 5px 0;
  align-items: center;
  flex: 0 1 33%;
}
@media only screen and (max-width: 1024px) {
    .history__vehicle {
        flex-flow: column nowrap;
        align-items: center;
        flex: 1;
        justify-content: center;
    }
    .history__vehicle--item{
        width: 100%;
        flex: 1 !important;
    }
    .history__vehicle--item--33 {
        flex: 1 !important;
        width: 100%;
    }
}
</style>
